
// This is an auto generated file - do not edit!
// Swagger path: /api/ProductType/{id}/permissions

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    EntityPermissionType
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class ProducttypeIdPermissionsApiService extends BaseApiService {
    
    get(id: string, options = {}): Observable<EntityPermissionType[]> {
        return this._get<EntityPermissionType[]>(
            `/ProductType/${id}/permissions`,
            options
        );
    }
}
